import { WorkStep } from "./types";

export const WORK_STEPS: readonly WorkStep[] = [
  {
    number: "01",
    title: "Connect your bank",
    description: "Securely link your business account through Open Banking. Repayas reads balances and transactions without storing your bank login.",
  },
  {
    number: "02",
    title: "Separate VAT from spendable cash",
    description: "Repayas shows what belongs to HMRC, what is already protected, and what remains safe for day-to-day spending.",
  },
  {
    number: "03",
    title: "Get the number before the weekend",
    description: "Every Friday, Repayas sends your Safe-to-Spend figure by SMS so you know what you can use without guessing.",
  },
] as const;
